
import { defineComponent, computed, ref, Ref } from "vue";
import { useStore } from "@/store";
import { useRouter, useRoute } from "vue-router";
import MenuTree from "./MenuTree.vue";
import { firstMenus } from "@/router";
export default defineComponent({
  props: {
    menuFold: {
      typeof: Boolean,
      default: false
    }
  },
  components: { MenuTree },
  name: "NavMenu",
  setup() {
    const store = useStore();

    const router = useRouter();

    const route = useRoute();
    const activeRouter: Ref<string> = computed(() => {
      return store.state.login.activeRouter;
    });

    const userMenus = computed(() => {
      return [firstMenus, ...store.state.login.userMenus];
    });

    return {
      userMenus,
      activeRouter
    };
  }
});
